export default __webpack_public_path__ + "static/media/app_store.2a8f2a38.png";